import styled from "styled-components";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { HXTextField } from "./base.styles";
import { fontWeights } from "healthex-common/weights";
import { HXButton } from "./HXButton";
import { colors } from "healthex-common/colors";
import { MoreInfo } from "./MoreInfo";
export const AdminInviteUserFormParent = styled.div ``;
export const InviteTable = styled(FlexColumnDiv) `
    gap: 16px;
    margin-bottom: 24px;
`;
export const InviteRow = styled(FlexRowDiv) `
    justify-content: space-between;
    gap: 24px;

    & > :nth-child(1) {
        width: 401px;
        & ${HXTextField} {
            width: 100%;
        }
    }
    & > :nth-child(2) {
        width: 86px;
    }
    & > :nth-child(3) {
        width: 142px;
    }
    & > :nth-child(4) {
        width: 110px;
    }
    & > :nth-child(5) {
        width: 86px;
    }
    & > :nth-child(2),
    & > :nth-child(3),
    & > :nth-child(4),
    & > :nth-child(5) {
        text-align: center;
    }
`;
export const InviteHeaderRow = styled(InviteRow) ``;
export const InviteHeaderLabel = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_light};
    display: flex;
    gap: 4px;
    align-items: center;
`;
export const AddAnotherButton = styled(HXButton) `
    margin-right: auto;
`;
export const BottomButtons = styled(FlexRowDiv) `
    width: 100%;
    & > * {
        flex-grow: 1;
    }
`;
export const CopyInviteButton = styled(HXButton) `
    flex-grow: 0;
`;
export const AdminInviteUserFormMoreInfo = styled(MoreInfo) `
    color: ${colors.black_lighter};
`;
